'use strict';

class LoaderView {
  constructor() {
    this.loader = document.getElementById('js-checkoutLoader');
    this.upgradeSection = document.getElementById('js-upgrade-section');
  }

  toggle(status) {
    this.upgradeSection.style.display = status ? "none" : "";
    this.loader.style.display = status ? "flex" : "none";
  }

}

module.exports = LoaderView;